/* eslint-disable */
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import saveStoreDraft from "../../utils/saveStoreDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import Spinner from "react-bootstrap/Spinner";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getAuth, updatePassword } from "firebase/auth";
import { logoutUser } from "../../redux/user/user";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Tooltip } from "antd";
import { Languages } from "lucide-react";
import i18n from "../../i18n";
import { reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import {
  User,
  Phone,
  Mail,
  Calendar,
  Lock,
  Save,
  Monitor,
  Smartphone,
  MapPin,
  Clock,
  LogOut,
  KeySquare,
  SquareAsterisk,
} from "lucide-react";
import IdentityVerification from "./verifyIdentity";
import { useTranslation } from "react-i18next";
import ContactSettings from "./ContactSettings";

function Account() {
  const account = useSelector((state) => state.AccountReducer);
  const currentLang = account.language || "ar";
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const auth = getAuth();
  const user = auth.currentUser;
  const [showSideBar, setShowSideBar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [data, setData] = useStoreFormDraft(account);
  const [activeStep, setActiveStep] = useState(1);
  const [qrCode, setQrCode] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);

  const [data2, setData2] = useState({
    oldPassword: "",
    password: "",
    passwordConfirmation: "",
  });
  const [activeTab, setActiveTab] = useState("tab1");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setDevices(account.devices || []);
  }, [account]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveStoreDraft(doc(db, "account", data.id), account, data);
      Swal.fire({
        icon: "success",
        title: t("AccountSettings.alerts.save_success.title"),
        confirmButtonText: t("AccountSettings.alerts.save_success.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.save_error.text"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();

    if (data2.password.length < 6) {
      return MySwal.fire({
        icon: "warning",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.password.too_short"),
        confirmButtonColor: "#9b59bf",
      });
    }

    if (data2.password !== data2.passwordConfirmation) {
      return MySwal.fire({
        icon: "warning",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.password.mismatch"),
        confirmButtonColor: "#9b59bf",
      });
    }

    setPasswordLoading(true);

    try {
      const credential = EmailAuthProvider.credential(
        user.email,
        data2.oldPassword
      );

      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, data2.password);

      dispatch(logoutUser(""));
      localStorage.setItem("token", "");

      MySwal.fire({
        icon: "success",
        title: t("AccountSettings.alerts.password.change_success"),
        confirmButtonText: t("AccountSettings.alerts.save_error.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      console.error("Error during password change:", error);
      MySwal.fire({
        icon: "error",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.password.wrong_old"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setPasswordLoading(false);
    }
  };

  const getDeviceImage = (deviceName) => {
    if (deviceName.includes("Windows")) {
      return "https://cdn-icons-png.flaticon.com/512/2504/2504927.png";
    }
    if (deviceName.includes("iPhone") || deviceName.includes("iOS")) {
      return "https://cdn-icons-png.flaticon.com/512/14776/14776639.png";
    }
    if (deviceName.includes("Android")) {
      return "https://cdn-icons-png.flaticon.com/128/2504/2504881.png";
    }
    return "https://cdn-icons-png.flaticon.com/512/1251/1251009.png";
  };

  const showDevicesModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleDeleteDevice = async (deviceName) => {
    try {
      const result = await Swal.fire({
        icon: "question",
        title: t("AccountSettings.alerts.device.confirm_logout_title"),
        text: t("AccountSettings.alerts.device.confirm_logout_text"),
        showCancelButton: true,
        confirmButtonText: t("AccountSettings.alerts.device.confirm"),
        cancelButtonText: t("AccountSettings.alerts.device.cancel"),
        confirmButtonColor: "#9b59bf",
        cancelButtonColor: "#d33",
      });

      if (result.isConfirmed) {
        const deviceToUpdate = devices.find(
          (device) => device.deviceName === deviceName
        );

        if (deviceToUpdate) {
          deviceToUpdate.isLoggedIn = false;

          await setDoc(
            doc(db, "account", account.id),
            {
              devices: devices.map((device) =>
                device.deviceName === deviceName ? deviceToUpdate : device
              ),
            },
            { merge: true }
          );

          const updatedDevices = devices.map((device) =>
            device.deviceName === deviceName ? deviceToUpdate : device
          );
          setDevices(updatedDevices);

          Swal.fire({
            icon: "success",
            title: t("AccountSettings.alerts.device.logout_success"),
            showConfirmButton: false,
            timer: 1500,
            confirmButtonColor: "#9b59bf",
          });
        }
      }
    } catch (error) {
      console.error("Error deleting device:", error);
    }
  };

  // Generate secret key and QR code
  useEffect(() => {
    generateSecretKey();
    loadDevices();
  }, []);

  const generateSecretKey = async () => {
    try {
      const res = await fetch(
        `https://backend-digital.foorweb.store/api/generateSecret?email=${account?.email}`
      );
      const data = await res.json();

      if (data.success) {
        setSecretKey(data.secret);
        setQrCode(data.qrUrl);
      }
    } catch (error) {
      console.error("Error generating secret:", error);
    }
  };

  const loadDevices = () => {
    // Simulate loading devices
    setDevices([

    ]);
  };

  const handleVerifyCode = async () => {
    if (verificationCode.length === 6 && secretKey) {
      try {
        const res = await fetch(
          "https://backend-digital.foorweb.store/api/verifyOtpGoogle",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              code: verificationCode,
              userSecret: secretKey,
              user: account?.user,
            }),
          }
        );

        const data = await res.json();

        if (data.success) {
          setIs2FAEnabled(true);
          setActiveStep(4);
          const accountRef = doc(db, "account", account?.id);
          await updateDoc(accountRef, {
            twoFAActivated: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: t("ui.wrongCode"),
            confirmButtonText: t("ship.ok"),
            confirmButtonColor: "#7e5395",
            timer: 3000,
            timerProgressBar: true,
            position: "bottom-end",
            toast: true,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("Error verifying code:", error);
      }
    }
  };

  const getDeviceIcon = (deviceName) => {
    if (deviceName.toLowerCase().includes("iphone")) return "📱";
    if (deviceName.toLowerCase().includes("macbook")) return "💻";
    if (deviceName.toLowerCase().includes("android")) return "📱";
    return "🖥️";
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };
  const isRTL = i18n.language === "ar";
  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("AccountSettings.page_title")}
                </h2>
                <p className="text-gray-600 mb-0">
                  {t("AccountSettings.page_subtitle")}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!border-[#3c3a3d] dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab1"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade] "
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab1")}
                >
                  {t("AccountSettings.tabs.account_info")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab2"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  {t("AccountSettings.tabs.change_password")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab3"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab3")}
                >
                  {t("AccountSettings.tabs.connected_devices")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab4"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab4")}
                >
                  {t("AccountSettings.tabs.2FA")}{" "}
                </button>
                {account?.productMode === "digital" && (
                  <button
                    className={`px-6 py-3 text-sm font-medium transition-colors ${
                      activeTab === "tab5"
                        ? "bg-[#fcf6ff] text-[#9e68ba] border-b-2 dark:text-gray-300 dark:bg-[#522868] border-[#bc7ade] dark:!border-[#3c3a3d]"
                        : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                    }`}
                    onClick={() => setActiveTab("tab5")}
                  >
                    {t("AccountSettings.tabs.identity_verification")}{" "}
                  </button>
                )}
                {account?.productMode === "digital" && (
                  <button
                    className={`px-6 py-3 text-sm font-medium transition-colors ${
                      activeTab === "tab6"
                        ? "bg-[#fcf6ff] text-[#9e68ba] border-b-2 dark:text-gray-300 dark:bg-[#522868] border-[#bc7ade] dark:!border-[#3c3a3d]"
                        : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                    }`}
                    onClick={() => setActiveTab("tab6")}
                  >
                    {t("ui.connectionDetails")}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="mx-3 mb-6">
            {/* Account Info Tab */}
            {activeTab === "tab1" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <User size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800  dark:text-gray-300">
                    {t("AccountSettings.account_info.title")}
                  </h3>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.account_info.name.label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <User size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="text"
                          value={data.name || ""}
                          onChange={(e) =>
                            setData({ ...data, name: e.target.value })
                          }
                          className="bg-white dark:!bg-[#181819] dark:text-gray-400 border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500"
                          placeholder={t(
                            "AccountSettings.account_info.name.placeholder"
                          )}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.account_info.phone.label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <Phone size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="text"
                          placeholder={t(
                            "AccountSettings.account_info.phone.label"
                          )}
                          value={data.phone || ""}
                          onChange={(e) =>
                            setData({ ...data, phone: e.target.value })
                          }
                          className="bg-white dark:!bg-[#181819] dark:text-gray-400 border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.account_info.email.label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <Mail size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="email"
                          placeholder={t(
                            "AccountSettings.account_info.email.label"
                          )}
                          value={data.email || ""}
                          disabled
                          className="bg-gray-50 dark:!bg-[#181819] dark:text-gray-400 border border-gray-300 dark:!border-[#3c3a3d] text-gray-600 text-sm rounded-lg block w-full py-3 pl-10 pr-10 cursor-not-allowed"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.account_info.birth.label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <Calendar size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="date"
                          value={data.birthDay || ""}
                          onChange={(e) =>
                            setData({ ...data, birthDay: e.target.value })
                          }
                          className="bg-white dark:!bg-[#181819] dark:text-gray-400 border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:pointer-events-none"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" />
                          <span className="mr-1">
                            {t("AccountSettings.saving")}
                          </span>
                        </>
                      ) : (
                        <>
                          <Save size={18} />
                          <span className="mr-1">
                            {" "}
                            {t("AccountSettings.save_button")}
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Password Change Tab */}
            {activeTab === "tab2" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <Lock size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                    {t("AccountSettings.change_password.title")}
                  </h3>
                </div>

                <form onSubmit={handleSubmit2}>
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                      {t("AccountSettings.change_password.old")}
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <KeySquare size={16} className="text-gray-400" />
                      </div>
                      <input
                        type="password"
                        placeholder={t("AccountSettings.change_password.old")}
                        value={data2.oldPassword}
                        onChange={(e) =>
                          setData2({
                            ...data2,
                            oldPassword: e.target.value,
                          })
                        }
                        className="bg-white dark:!bg-[#181819] dark:!text-[#3c3ad] dark:!text-gray-400 border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500  p-2.5  focus:outline-none focus:ring-2 "
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.change_password.new")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <SquareAsterisk size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="password"
                          placeholder={t("AccountSettings.change_password.new")}
                          value={data2.password}
                          onChange={(e) =>
                            setData2({ ...data2, password: e.target.value })
                          }
                          className={`bg-white border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-[#3c3ad] dark:!text-gray-400 text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500  p-2.5  focus:outline-none focus:ring-2  ${
                            data2.password.length > 0 &&
                            data2.password.length < 6
                              ? "border-red-300"
                              : "border-gray-300"
                          }`}
                          required
                        />
                        {data2.password.length > 0 &&
                          data2.password.length < 6 && (
                            <p className="mt-1 text-sm text-red-500">
                              {t("AccountSettings.change_password.too_short")}
                            </p>
                          )}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.change_password.confirm")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <SquareAsterisk size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="password"
                          placeholder={t(
                            "AccountSettings.change_password.confirm"
                          )}
                          value={data2.passwordConfirmation}
                          onChange={(e) =>
                            setData2({
                              ...data2,
                              passwordConfirmation: e.target.value,
                            })
                          }
                          className={`bg-white border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-[#3c3ad] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500  p-2.5  focus:outline-none focus:ring-2  ${
                            data2.passwordConfirmation.length > 0 &&
                            data2.password !== data2.passwordConfirmation
                              ? "border-red-300"
                              : "border-gray-300"
                          }`}
                          required
                        />
                        {data2.passwordConfirmation.length > 0 &&
                          data2.password !== data2.passwordConfirmation && (
                            <p className="mt-1 text-sm text-red-500">
                              {t("AccountSettings.change_password.not_match")}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:pointer-events-none"
                      disabled={
                        passwordLoading ||
                        data2.oldPassword.length === 0 ||
                        data2.password.length < 6 ||
                        data2.password !== data2.passwordConfirmation
                      }
                    >
                      {passwordLoading ? (
                        <>
                          <Spinner animation="border" size="sm" />
                          <span className="mr-1">
                            {t("AccountSettings.saving")}
                          </span>
                        </>
                      ) : (
                        <>
                          <Save size={18} />
                          <span className="mr-1">
                            {t("AccountSettings.change_password.button")}
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Connected Devices Tab */}
             {activeTab === "tab3" && (
              <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center">
                    <Monitor size={20} className="text-[#9e68ba] ml-2" />
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t("AccountSettings.tabs.connected_devices")}
                    </h3>
                  </div>
                  <div>
                    <Tooltip title={t("AccountSettings.connected_devices.active_devices_count_tooltip")}>
                      <span className="inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-full bg-purple-100 text-[#9e65bb]">
                        {devices?.filter((d) => d.isLoggedIn === true)
                          ?.length || 0}{" "}
                        {t("AccountSettings.connected_devices.device_count_label")}
                      </span>
                    </Tooltip>
                  </div>
                </div>

                <p className="text-gray-600 mb-6">
                  {t("AccountSettings.connected_devices.description")}
                </p>

                {Array.isArray(devices) &&
                devices.filter((d) => d.isLoggedIn === true).length > 0 ? (
                  <div className="space-y-4">
                    {devices
                      .filter((device) => device.isLoggedIn === true)
                      .map((device) => (
                        <div
                          key={device.deviceName}
                          className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-purple-200 transition-colors"
                        >
                          <div className="flex items-center gap-4">
                            <div className="h-10 w-10 rounded-full bg-[#fcf6ff] p-1 flex items-center justify-center">
                              <img
                                src={getDeviceImage(device.deviceName)}
                                className="h-7 w-7 object-contain"
                                alt={device.deviceName}
                              />
                            </div>
                            <div>
                              <h4 className="font-medium text-gray-900">
                                {device.deviceName}
                              </h4>
                              <div className="text-sm text-gray-500 space-y-1">
                                <div className="flex items-center gap-1">
                                  <Clock size={14} />
                                  <span>
                                    {t("ui.lastUsedLabel")}{" "}
                                    {device.timestamp && device.timestamp.toDate
                                      ? new Date(
                                          device.timestamp.seconds * 1000
                                        ).toLocaleString()
                                      : t("AccountSettings.connected_devices.unavailable")}
                                  </span>
                                </div>
                                {device.location && (
                                  <div className="flex items-center gap-1">
                                    <MapPin size={14} />
                                    <span>
                                      {device.location.country &&
                                      device.location.region
                                        ? `${device.location.region} - ${device.location.country}`
                                        : t("AccountSettings.connected_devices.location_unavailable")}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <button
                            onClick={() =>
                              handleDeleteDevice(device.deviceName)
                            }
                            className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-red-50 text-gray-700 hover:text-red-600 rounded-lg transition-colors text-sm"
                          >
                            <LogOut size={16} />
                            <span>{t("logout")}</span>
                          </button>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <div className="w-16 h-16 bg-gray-100 rounded-full mx-auto flex items-center justify-center mb-4">
                      <Smartphone size={24} className="text-gray-400" />
                    </div>
                    <h4 className="text-gray-700 font-medium mb-2">
                      {t("AccountSettings.connected_devices.no_devices.title")}
                    </h4>
                    <p className="text-gray-500 text-sm">
                      {t("AccountSettings.connected_devices.no_devices.description")}
                    </p>
                  </div>
                )}
              </div>
            )}
            {/* {activeTab === "tab3" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center">
                    <Monitor size={20} className="text-[#9e68ba] ml-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                      {t("AccountSettings.connected_devices.title")}
                    </h3>
                  </div>
                  <div>
                    <Tooltip
                      title={t(
                        "AccountSettings.connected_devices.active_devices_count_tooltip"
                      )}
                    >
                      <span className="inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-full bg-purple-100 text-[#9e65bb]">
                        {devices?.filter((d) => d.isLoggedIn === true)
                          ?.length || 0}{" "}
                        جهاز
                      </span>
                    </Tooltip>
                  </div>
                </div>

                <p className="text-gray-600 mb-6 dark:!text-gray-400">
                  {t("AccountSettings.connected_devices.description")}
                </p>

                {Array.isArray(devices) &&
                devices.filter((d) => d.isLoggedIn === true).length > 0 ? (
                  <div className="space-y-4">
                    {devices
                      .filter((device) => device.isLoggedIn === true)
                      .map((device) => (
                        <div
                          key={device.deviceName}
                          className="flex items-center justify-between p-4 border border-gray-200 dark:!border-[#3c3a3d] rounded-lg hover:border-purple-200 transition-colors"
                        >
                          <div className="flex items-center gap-4">
                            <div className="h-10 w-10 rounded-full bg-[#fcf6ff] p-1 flex items-center justify-center">
                              <img
                                src={getDeviceImage(device.deviceName)}
                                className="h-7 w-7 object-contain"
                                alt={device.deviceName}
                              />
                            </div>
                            <div>
                              <h4 className="font-medium text-gray-900 dark:!text-gray-300">
                                {device.deviceName}
                              </h4>
                              <div className="text-sm text-gray-500 dark:!text-gray-400 space-y-1">
                                <div className="flex items-center gap-1">
                                  <Clock size={14} />
                                  <span className="dark:!text-gray-400">
                                    {t(
                                      "AccountSettings.connected_devices.last_active"
                                    )}{" "}
                                    {device.timestamp && device.timestamp.toDate
                                      ? new Date(
                                          device.timestamp.seconds * 1000
                                        ).toLocaleString()
                                      : t(
                                          "AccountSettings.connected_devices.unavailable"
                                        )}
                                  </span>
                                </div>
                                {device.location && (
                                  <div className="flex items-center gap-1 ">
                                    <MapPin size={14} />
                                    <span className="dark:!text-gray-400">
                                      {device.location.country &&
                                      device.location.region
                                        ? `${device.location.region} - ${device.location.country}`
                                        : t(
                                            "AccountSettings.connected_devices.location_unavailable"
                                          )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <button
                            onClick={() =>
                              handleDeleteDevice(device.deviceName)
                            }
                            className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-red-50 text-gray-700 hover:text-red-600 rounded-lg transition-colors text-sm"
                          >
                            <LogOut size={16} />
                            <span>
                              {" "}
                              {t(
                                "AccountSettings.connected_devices.logout_button"
                              )}
                            </span>
                          </button>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <div className="w-16 h-16 bg-gray-100 rounded-full mx-auto flex items-center justify-center mb-4">
                      <Smartphone size={24} className="text-gray-400" />
                    </div>
                    <h4 className="text-gray-700 font-medium mb-2">
                      {t("AccountSettings.connected_devices.no_devices.title")}
                    </h4>
                    <p className="text-gray-500 text-sm">
                      {t(
                        "AccountSettings.connected_devices.no_devices.description"
                      )}
                    </p>
                  </div>
                )}
              </div>
            )} */}

            {/* 2FA */}
            {activeTab === "tab4" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <Lock size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                    {t("AccountSettings.twoFA.title")}
                  </h3>
                </div>

                <div className="max-w-4xl mx-auto">
                  {/* Header */}
                  <div className="text-center mb-8">
                    <p className="text-gray-600 dark:!text-gray-400">
                      {t("AccountSettings.twoFA.subtitle")}
                    </p>
                  </div>

                  {/* Progress Steps */}
                  {account && !account?.twoFAActivated && (
                    <div className="flex justify-center mb-8">
                      <div className="flex items-center space-x-4 rtl:space-x-reverse">
                        {[1, 2, 3, 4].map((step) => (
                          <div key={step} className="flex items-center">
                            <div
                              className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium ${
                                activeStep >= step
                                  ? "bg-[#9e68ba] text-white"
                                  : "bg-gray-200 text-gray-600"
                              }`}
                            >
                              {step}
                            </div>
                            {step < 4 && (
                              <div
                                className={`w-16 h-1 mx-2 ${
                                  activeStep > step
                                    ? "bg-[#9e68ba]"
                                    : "bg-gray-200"
                                }`}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Step 1: Download App */}
                  {account && activeStep === 1 && !account?.twoFAActivated && (
                    <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-lg p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                      <div className="text-center">
                        <div className="w-20 h-20 bg-purple-100 dark:!bg-[#141414] rounded-full mx-auto mb-6 flex items-center justify-center">
                          <span className="text-4xl">📱</span>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 dark:!text-white mb-4">
                          {t("AccountSettings.twoFA.steps.downloadApp.title")}
                        </h2>
                        <p className="text-gray-600 dark:!text-gray-300 mb-8">
                          {t(
                            "AccountSettings.twoFA.steps.downloadApp.description"
                          )}
                        </p>

                        <div className="flex justify-center space-x-4 rtl:space-x-reverse mb-8">
                          <a
                            href="#"
                            className="bg-black text-white px-6 py-3 rounded-lg flex items-center space-x-2 rtl:space-x-reverse hover:bg-gray-800 transition-colors"
                          >
                            <span>🍎</span>
                            <span>
                              {t(
                                "AccountSettings.twoFA.steps.downloadApp.buttons.appStore"
                              )}
                            </span>
                          </a>
                          <a
                            href="#"
                            className="bg-green-600 text-white px-6 py-3 rounded-lg flex items-center space-x-2 rtl:space-x-reverse hover:bg-green-700 transition-colors"
                          >
                            <span>🤖</span>
                            <span>
                              {t(
                                "AccountSettings.twoFA.steps.downloadApp.buttons.googlePlay"
                              )}
                            </span>
                          </a>
                        </div>

                        <button
                          onClick={() => setActiveStep(2)}
                          className="bg-[#9e68ba] text-white px-8 py-3 rounded-lg hover:bg-[#814a9f] transition-colors font-medium"
                        >
                          {t(
                            "AccountSettings.twoFA.steps.downloadApp.buttons.next"
                          )}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 2: Scan QR Code */}
                  {account && activeStep === 2 && !account?.twoFAActivated && (
                    <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-lg p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                      <div className="text-center">
                        <h2 className="text-2xl font-bold text-gray-800 dark:!text-white mb-4">
                          {t("AccountSettings.twoFA.steps.scanQRCode.title")}
                        </h2>
                        <p className="text-gray-600 dark:!text-gray-300 mb-8">
                          {t(
                            "AccountSettings.twoFA.steps.scanQRCode.description"
                          )}
                        </p>

                        <div className="bg-gray-50 dark:!bg-[#141414] p-6 rounded-lg mb-6 inline-block">
                          <img
                            src={qrCode || "/placeholder.svg"}
                            alt={t("ui.qrCode")}
                            className="w-48 h-48 mx-auto"
                          />
                        </div>

                        <div className="bg-yellow-50 dark:!bg-[#141414] border border-yellow-200 dark:!border-[#3c3a3d] rounded-lg p-4 mb-6">
                          <p className="text-sm text-yellow-800 dark:!text-gray-300 mb-2">
                            {t(
                              "AccountSettings.twoFA.steps.scanQRCode.manualKey.text"
                            )}
                          </p>
                          <div className="flex items-center justify-center space-x-2 rtl:space-x-reverse">
                            <code className="bg-white dark:!bg-[#181919] px-3 py-1 rounded border dark:!border-[#3c3a3d] text-sm font-mono dark:!text-white">
                              {secretKey}
                            </code>
                            <button
                              onClick={() => copyToClipboard(secretKey)}
                              className="text-[#9e68ba] hover:text-[#814a9f] text-sm"
                            >
                              {t(
                                "AccountSettings.twoFA.steps.scanQRCode.manualKey.copy"
                              )}
                            </button>
                          </div>
                        </div>

                        <button
                          onClick={() => setActiveStep(3)}
                          className="bg-[#9e68ba] text-white px-8 py-3 rounded-lg hover:bg-[#814a9f] transition-colors font-medium"
                        >
                          {t("AccountSettings.twoFA.steps.scanQRCode.next")}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 3: Verify Code */}
                  {account &&
                    activeStep === 3 &&
                    !is2FAEnabled &&
                    !account?.twoFAActivated && (
                      <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-lg p-8 border border-purple-100 dark:!border-[#3c3a3d]">
                        <div className="text-center">
                          <h2 className="text-2xl font-bold text-gray-800 dark:!text-white mb-4">
                            {t("AccountSettings.twoFA.steps.verifyCode.title")}
                          </h2>
                          <p className="text-gray-600 dark:!text-gray-300 mb-8">
                            {t(
                              "AccountSettings.twoFA.steps.verifyCode.description"
                            )}
                          </p>

                          <div className="max-w-xs mx-auto mb-6">
                            <input
                              type="text"
                              value={verificationCode}
                              onChange={(e) =>
                                setVerificationCode(
                                  e.target.value.replace(/\D/g, "").slice(0, 6)
                                )
                              }
                              placeholder="000000"
                              className="w-full text-center text-2xl font-mono py-4 px-4 border-2 border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#141414] dark:!text-white rounded-lg focus:border-[#814a9f] focus:outline-none"
                              maxLength={6}
                            />
                          </div>
                          <button
                            onClick={handleVerifyCode}
                            disabled={verificationCode.length !== 6}
                            className="bg-[#9e68ba] text-white px-8 py-3 rounded-lg hover:bg-[#814a9f] transition-colors font-medium disabled:bg-gray-300 disabled:cursor-not-allowed dark:!disabled:bg-[#3c3a3d]"
                          >
                            {t("AccountSettings.twoFA.steps.verifyCode.button")}
                          </button>
                        </div>
                      </div>
                    )}
                  {/* Step 4: Manage Devices */}
                  {account && account?.twoFAActivated && (
                    <div className="space-y-6">
                      {/* 2FA Status */}
                      <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-lg p-6 border border-purple-100 dark:!border-[#3c3a3d]">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-3 rtl:space-x-reverse">
                            <div className="w-12 h-12 bg-green-100 dark:!bg-[#141414] rounded-full flex items-center justify-center">
                              <span className="text-2xl">🔐</span>
                            </div>
                            <div>
                              <h3 className="text-lg font-semibold text-gray-800 dark:!text-white">
                                {t("AccountSettings.twoFA.steps.status.title")}
                              </h3>
                              <p className="text-green-600 dark:!text-green-400 text-sm">
                                {t(
                                  "AccountSettings.twoFA.steps.status.enabled"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Navigation */}
                  {activeStep > 1 && activeStep < 4 && (
                    <div className="flex justify-center mt-8">
                      <button
                        onClick={() => setActiveStep(activeStep - 1)}
                        className="px-6 py-2 text-[#9e68ba] hover:text-[#814a9f] transition-colors"
                      >
                        {t("AccountSettings.twoFA.steps.navigation.previous")}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "tab5" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <IdentityVerification />
              </div>
            )}

            {activeTab === "tab6" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <ContactSettings />
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Account;
